/* global G */
import { asyncPipeSpread, bulk } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { disable } from 'lib/sequence/component/state/disabled'
import { hide } from 'lib/sequence/component/state/hidden'
import asObject from 'lib/sequence/component/children/asObject'

const bulkDisable = bulk(disable)

/**
 * If the model's user is external, disables all fields.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*, ...[*]): *[]}
 */
const disableFieldsForExternalUser = module => (components, ...args) => {
  const model = module[G.MODEL]
  const user = model[G.CACHE]
  const { remoteAuthentication, custom } = user.value

  if (remoteAuthentication || custom) {
    const { component, firstName, lastName, phone, email } = components
    const { btnRedirect } = asObject(component[G.ACTIONS][0][G.CHILDREN])
    bulkDisable(firstName, lastName, phone, email)
    hide(btnRedirect)
  }

  return [components, ...args]
}

export default module => component => async (...args) => asyncPipeSpread(
  disableFieldsForExternalUser(module),
  (components, ...argv) => argv,
)(find(component), ...args)
